
/**
* @since 08112022
* @author V S K Rambabu. V
* @purpose PrintJsPdfHandlerService for Print and Export PDF from API Response PDF Stream.
*/
; (function () {
    angular.module('EMR.Admin').service("PrintJsPdfHandlerService", printJsPdfHandlerService);

    printJsPdfHandlerService.$inject = ['CommonPostService', '$q'];

    function printJsPdfHandlerService(CommonPostService, $q) {
        /**
         * @function print Used to Print the API Call Response PDF Stream 
         * @param {API Method URL} apiUrl 
         * @param {Input Model} postData 
         * @options { timeout : value,
                     isErrorCallBackRequired : value,
                     ExceptionalWCF : value,
                     SendRequestToThisServerURL : value,
                     RequestHeader : value } Object holds the following key:value pairs if these required for method, Pass which are needed.
         */
        this.print = function (apiUrl, postData, options) {
            if (!apiUrl && !postData) return;
            if (!options) options = {};
            postData.isBlobResponseType = true; //passing isBlobResponseType inorder to have the Response type blob from http.post Method
            CommonPostService.httpPostData('POST', apiUrl, postData, options.timeout, options.isErrorCallBackRequired, options.ExceptionalWCF, options.SendRequestToThisServerURL, options.RequestHeader).then(function (serviceResponse) {
                printResponseStreamInfo(serviceResponse);
            });
        };
        /**
         * @function print Used to Export the API Call Response PDF Stream 
         * @param {API Method URL} apiUrl 
         * @param {Input Model} postData 
         * @options { timeout : value,
                     isErrorCallBackRequired : value,
                     ExceptionalWCF : value,
                     SendRequestToThisServerURL : value,
                     RequestHeader : value } Object holds the following key:value pairs if these required for method, Pass which are needed.
         */
        this.exportPDF = function (apiUrl, postData, options) {
            if (!apiUrl && !postData) return;
            if (!options) options = {};
            postData.isBlobResponseType = true; //passing isBlobResponseType inorder to have the Response type blob from http.post Method
            CommonPostService.httpPostData('POST', apiUrl, postData, options.timeout, options.isErrorCallBackRequired, options.ExceptionalWCF, options.SendRequestToThisServerURL, options.RequestHeader).then(function (serviceResponse) {
                exportPDFResponseStreamInfo(serviceResponse, postData.title);
            });
        };

        /**
         * @printResponseStreamInfo Print Response PDF Stream Blob File and Pass the stream to PrintJs library for Print
         * @param {*} printResponseInfo 
         */
        function printResponseStreamInfo(printResponseInfo) {
            if (printResponseInfo) {
                readBlobFile(printResponseInfo).then(function (formattedResponseFromAPI) {
                    if (formattedResponseFromAPI) {
                        //Passing to the PrintJs
                        printJS({
                            printable: formattedResponseFromAPI.split('base64,')[1],
                            type: 'pdf',
                            base64: true
                        });
                    }
                    //else ShowErrorMessage("No Data Found to Print.");
                });
            }
        }

        /**
         * @function exportPDFResponseStreamInfo Used to Download Response PDF Stream File 
         * @param {*} pdfResponseInfo 
         * @param {string} title 
         */
        function exportPDFResponseStreamInfo(pdfResponseInfo, title) {
            if (pdfResponseInfo) {
                readBlobFile(pdfResponseInfo, true).then(function (isValidPDF) {
                    if (isValidPDF) {
                        let link = URL.createObjectURL(pdfResponseInfo);
                        let element = document.createElement("a");
                        element.setAttribute("download", title || "EHR PDF File");
                        element.setAttribute("href", link);
                        document.body.appendChild(element);
                        element.click();
                        document.body.removeChild(element);
                    }
                })
            }
        }

        /**
         * @method readBlobFile
         * @purpose Converts blob type file to text
         * @return {Promise}
        **/
        function readBlobFile(file, callingFromPDFFormat) {
            let deferred = $q.defer();
            if (file) {
                const reader = new FileReader();//initiazing the File Reader to read blob file
                reader.preservedBlob = file;
                reader.promise = deferred;
                reader.readAsText(file);
                reader.onload = (callingFromPDFFormat) ? readingPDFResponseFromAPI : readingPrintResponseFromAPI;
                reader.onerror = function (error) {
                    deferred.reject(error);
                };
            }
            //else ShowErrorMessage("No File Found.");
            return deferred.promise;
        }


        /**
         * @function readingPrintResponseFromAPI
         * @description TO VALIDATE THE PRINT RESPONSE AND READ THE PRINT FILE
         * */
        function readingPrintResponseFromAPI() {
            if (this.result && this.result.contains("ErrorMessage") && this.result.contains("ResponseID")) {
                let responseModel = JSON.parse(this.result) || {};
                ShowErrorMessage(_.get(responseModel, "ErrorMessage") || "No Data Available to Print.");
                this.promise.reject(false);
            }
            else {
                const pdfFileReader = new FileReader();
                pdfFileReader.promise = this.promise;
                pdfFileReader.readAsDataURL(this.preservedBlob);//Obtaining the blob file URL by Passing it
                pdfFileReader.onload = function () {
                    pdfFileReader.promise.resolve(pdfFileReader.result);
                };
                pdfFileReader.onerror = function (error) {
                    pdfFileReader.promise.reject(error);
                };
            }

        };

        /**
         * @function readingPDFResponseFromAPI
         * @description TO VALIDATE THE PDF RESPONSE AND READ THE PRINT FILE
        * */
        function readingPDFResponseFromAPI() {
            if (this.result && this.result.contains("ErrorMessage") && this.result.contains("ResponseID")) {
                let responseModel = JSON.parse(this.result) || {};
                ShowErrorMessage(_.get(responseModel, "ErrorMessage") || "No Data Available to Export PDF");
                this.promise.reject(false);
            }
            else this.promise.resolve(true);
        }
    }
})();
